import React, { useState, useEffect, useCallback } from 'react';
import { getTagFreshFeed, getTagPopularFeed, getTagRisingFeed } from '../lib/tags';
import { COLORS, SPACING } from '../styles/theme';

export function TagDetail({ tag, onBack, onViewUserProfile, onViewVideo }: { tag: string; onBack: () => void; onViewUserProfile: (userId: string) => void; onViewVideo: (hash: string) => void }) {
  const [feedType, setFeedType] = useState<'fresh' | 'rising' | 'popular'>('popular');
  const [videos, setVideos] = useState<any[]>([]);

  const loadFeed = useCallback(() => {
    let feed;
    if (feedType === 'fresh') feed = getTagFreshFeed(tag);
    else if (feedType === 'rising') feed = getTagRisingFeed(tag);
    else feed = getTagPopularFeed(tag);
    
    setVideos(feed);
  }, [feedType, tag]);

  useEffect(() => {
    loadFeed();
  }, [loadFeed]);

  return (
    <div style={{
      border: `2px outset ${COLORS.highlight}`,
      backgroundColor: COLORS.panel,
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      height: '100%'
    }}>
      <div style={{
        backgroundColor: COLORS.accent,
        color: '#fff',
        padding: `${SPACING.xs} ${SPACING.sm}`,
        fontSize: '9px',
        fontWeight: 700,
        borderBottom: `2px solid ${COLORS.highlight}`,
        userSelect: 'none',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <span>Tag: {tag}</span>
        <button
          onClick={onBack}
          style={{
            backgroundColor: 'transparent',
            color: '#fff',
            border: 'none',
            cursor: 'pointer',
            fontSize: '12px',
            fontWeight: 700
          }}
        >
          ✕
        </button>
      </div>

      <div style={{
        padding: SPACING.lg,
        backgroundColor: COLORS.bg,
        borderBottom: `1px solid ${COLORS.border}`,
        display: 'flex',
        gap: SPACING.sm
      }}>
        {['fresh', 'rising', 'popular'].map(type => (
          <button
            key={type}
            onClick={() => setFeedType(type as any)}
            style={{
              padding: `${SPACING.sm} ${SPACING.lg}`,
              backgroundColor: feedType === type ? COLORS.accent : COLORS.panel,
              color: feedType === type ? '#fff' : COLORS.text,
              border: `2px outset ${feedType === type ? COLORS.accent : COLORS.highlight}`,
              cursor: 'pointer',
              fontFamily: 'monospace',
              fontSize: '9px',
              fontWeight: 700,
              textDecoration: 'underline',
              textTransform: 'capitalize',
              boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.5)'
            }}
            onMouseDown={(e) => {
              e.currentTarget.style.borderStyle = 'inset';
              e.currentTarget.style.boxShadow = 'inset 1px 1px 2px rgba(0,0,0,0.8)';
            }}
            onMouseUp={(e) => {
              e.currentTarget.style.borderStyle = 'outset';
              e.currentTarget.style.boxShadow = 'inset 0 0 0 1px rgba(0,0,0,0.5)';
            }}
          >
            {type}
          </button>
        ))}
      </div>

      <div style={{ flex: 1, overflowY: 'auto', backgroundColor: COLORS.bg }}>
        {videos.length === 0 ? (
          <p style={{ padding: SPACING.lg, color: COLORS.textMuted, margin: 0, fontSize: '10px' }}>
            No videos
          </p>
        ) : (
          videos.map((item: any, idx) => (
            <div
              key={item.videoHash}
              onClick={() => onViewVideo(item.videoHash)}
              style={{
                padding: SPACING.lg,
                borderBottom: `1px solid ${COLORS.border}`,
                cursor: 'pointer',
                backgroundColor: idx % 2 === 0 ? COLORS.bg : 'rgba(139, 30, 45, 0.05)',
                transition: 'all 0.1s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(139, 30, 45, 0.1)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = idx % 2 === 0 ? COLORS.bg : 'rgba(139, 30, 45, 0.05)';
              }}
            >
              <h4 style={{
                margin: `0 0 ${SPACING.sm} 0`,
                fontSize: '12px',
                fontFamily: 'monospace',
                fontWeight: 700,
                fontStyle: 'italic',
                color: COLORS.accent
              }}>
                {item.video?.title}
              </h4>
              <p style={{
                margin: `0 0 ${SPACING.sm} 0`,
                fontSize: '8px',
                color: COLORS.textMuted,
                fontWeight: 700
              }}>
                By{' '}
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onViewUserProfile(item.video?.uploader);
                  }}
                  style={{
                    backgroundColor: 'transparent',
                    color: COLORS.accent,
                    border: 'none',
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    fontSize: 'inherit',
                    fontFamily: 'inherit'
                  }}
                >
                  {item.video?.uploader.slice(0, 8)}
                </button>
                {' '} | {new Date(item.uploadedAt).toLocaleDateString()} | {item.pinCount} pins
              </p>
              <p style={{
                margin: 0,
                fontSize: '10px',
                color: COLORS.text
              }}>
                {item.video?.description?.slice(0, 80)}
              </p>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
